import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@app/shared/shared.module';
import { EmbedContactComponent } from './embed-contact/embed-contact.component';

const routes: Routes = [
  {
    path: 'contact/:id',
    component: EmbedContactComponent,
  },
];

@NgModule({
  declarations: [EmbedContactComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes)],
})
export class EmbedContactModule {}
